import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import {
  ID_GLUE,
  SAVED_MEAL_PREFIX,
  type SavedMealId,
} from '../../domain/saved-meal-id.value-object';

export class SavedMealIdValidator implements Validator<SavedMealId> {
  readonly standardSchema = z.templateLiteral([SAVED_MEAL_PREFIX, ID_GLUE, z.string().min(1)]);

  validate(value: unknown): Result<SavedMealId, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid saved meal id.'));
    }
    return ok(parsed.data);
  }
}
